export * from './remove-from-cart.component'
export { RemoveFromCartIcon } from './remove-from-cart-icon.component'
